
import { useEffect, useState, useRef, useCallback } from 'react';

import { ChevronRight, ChevronLeft, Clock, TrendingUp, Target, Mail, Zap, CheckCircle, X, AlertCircle, Brain, Rocket, Users } from 'lucide-react';

        const FundraisingWorkshop = () => {
            const [currentSlide, setCurrentSlide] = useState(0);
            const [animationKey, setAnimationKey] = useState(0);

            const nextSlide = () => {
                if (currentSlide < slides.length - 1) {
                    setCurrentSlide(currentSlide + 1);
                    setAnimationKey(prev => prev + 1);
                }
            };

            const prevSlide = () => {
                if (currentSlide > 0) {
                    setCurrentSlide(currentSlide - 1);
                    setAnimationKey(prev => prev + 1);
                }
            };

            useEffect(() => {
                const handleKeyPress = (e) => {
                    if (e.key === 'ArrowRight') nextSlide();
                    if (e.key === 'ArrowLeft') prevSlide();
                };
                window.addEventListener('keydown', handleKeyPress);
                return () => window.removeEventListener('keydown', handleKeyPress);
            }, [currentSlide]);

            const slides = [
                // Slide 1: Title
                {
                    content: (
                        <div className="flex flex-col items-center justify-center h-full text-center">
                            <div className="mb-8 animate-bounce">
                                <Brain size={80} className="text-purple-400" />
                            </div>
                            <h1 className="text-6xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
                                Fundraising in 2025
                            </h1>
                            <p className="text-2xl text-gray-800 mb-8">From Academic Pace to Startup Speed</p>
                            <div className="bg-purple-900/30 px-8 py-4 rounded-xl">
                                <p className="text-xl">How to raise $1-2M in 6 weeks, not 6 months</p>
                            </div>
                        </div>
                    )
                },
                // Slide 2: Old Way vs New Way
               // Replace the existing Slide 2 with these two new slides:

// Slide 2: Why Academia's Approach Fails in Startups
{
    content: (
        <div className="h-full p-16">
            <h2 className="text-4xl font-bold mb-12 text-center">Why Academia's Approach Fails in Startups</h2>
            <div className="space-y-6">
                <div className="bg-red-900/20 border border-red-500/50 rounded-xl p-6">
                    <h3 className="text-2xl font-bold mb-4 text-red-400 flex items-center">
                        <X size={32} className="mr-3" />
                        The Connector Dependency Problem
                    </h3>
                    <p className="text-lg mb-3">In academia, senior people coordinate everything. In startups, this kills deals because:</p>
                    <ul className="space-y-2 text-lg ml-6">
                        <li>• Connectors are doing YOU a favor - they're not your assistant</li>
                        <li>• Every extra step = 50% drop in success rate</li>
                        <li>• Investors judge your ability to execute by how you handle intros</li>
                    </ul>
                </div>
                
                <div className="bg-orange-900/20 border border-orange-500/50 rounded-xl p-6">
                    <h3 className="text-2xl font-bold mb-4 text-orange-400 flex items-center">
                        <Clock size={32} className="mr-3" />
                        The Time Mismatch
                    </h3>
                    <p className="text-lg mb-3">Academic timelines are built for deliberation. Startup timelines are built for survival:</p>
                    <ul className="space-y-2 text-lg ml-6">
                        <li>• VCs see 1000+ deals/year - they decide in days, not months</li>
                        <li>• Hot markets cool down - AI healthcare won't be hot forever</li>
                        <li>• Your competitors are moving at startup speed RIGHT NOW</li>
                    </ul>
                </div>
                
                <div className="bg-yellow-900/20 border border-yellow-500/50 rounded-xl p-6">
                    <h3 className="text-2xl font-bold mb-4 text-yellow-400 flex items-center">
                        <AlertCircle size={32} className="mr-3" />
                        The Signal You're Sending
                    </h3>
                    <p className="text-lg">When you move slowly and rely on others to organize meetings, investors think:</p>
                    <p className="text-xl font-bold mt-3 text-center">"If they can't even manage their own fundraising process, how will they build a company?"</p>
                </div>
            </div>
        </div>
    )
},
// Slide 3: The Startup Way That Works
{
    content: (
        <div className="h-full p-16">
            <h2 className="text-4xl font-bold mb-8 text-center">The Startup Way That Works</h2>
            <div className="grid grid-cols-1 gap-4">
                <div className="bg-green-900/20 border border-green-500/50 rounded-xl p-5">
                    <h3 className="text-xl font-bold mb-3 text-green-400 flex items-center">
                        <Zap size={28} className="mr-2" />
                        Speed as a Competitive Advantage
                    </h3>
                    <div className="grid grid-cols-3 gap-4 text-center">
                        <div className="bg-green-800/20 rounded p-3">
                            <p className="font-bold text-green-300">2 hours</p>
                            <p className="text-sm">Reply to intros</p>
                        </div>
                        <div className="bg-green-800/20 rounded p-3">
                            <p className="font-bold text-green-300">THIS week</p>
                            <p className="text-sm">Book calls</p>
                        </div>
                        <div className="bg-green-800/20 rounded p-3">
                            <p className="font-bold text-green-300">Same day</p>
                            <p className="text-sm">Send follow-ups</p>
                        </div>
                    </div>
                    <p className="text-lg font-bold mt-3 text-green-300 text-center">Fast founders win. Slow founders explain why they lost.</p>
                </div>
                
                <div className="bg-blue-900/20 border border-blue-500/50 rounded-xl p-5">
                    <h3 className="text-xl font-bold mb-3 text-blue-400 flex items-center">
                        <Target size={28} className="mr-2" />
                        Direct Ownership - You Drive Everything
                    </h3>
                    <div className="flex items-center justify-between text-sm">
                        <div className="text-center flex-1">
                            <div className="bg-blue-800/30 rounded p-2">Intro received</div>
                        </div>
                        <ChevronRight className="text-blue-400 mx-1" size={20} />
                        <div className="text-center flex-1">
                            <div className="bg-blue-800/30 rounded p-2">You take over</div>
                        </div>
                        <ChevronRight className="text-blue-400 mx-1" size={20} />
                        <div className="text-center flex-1">
                            <div className="bg-blue-800/30 rounded p-2">Send calendar</div>
                        </div>
                        <ChevronRight className="text-blue-400 mx-1" size={20} />
                        <div className="text-center flex-1">
                            <div className="bg-blue-800/30 rounded p-2 font-bold">Create urgency</div>
                        </div>
                    </div>
                </div>
                
                <div className="bg-purple-900/20 border border-purple-500/50 rounded-xl p-5">
                    <h3 className="text-xl font-bold mb-3 text-purple-400 flex items-center">
                        <Rocket size={28} className="mr-2" />
                        Momentum Building Machine
                    </h3>
                    <div className="flex items-center justify-center space-x-2 text-sm">
                        <div className="bg-purple-800/30 px-3 py-2 rounded">Quick reply</div>
                        <ChevronRight className="text-purple-400" size={16} />
                        <div className="bg-purple-800/30 px-3 py-2 rounded">Fast booking</div>
                        <ChevronRight className="text-purple-400" size={16} />
                        <div className="bg-purple-800/30 px-3 py-2 rounded">Instant follow-up</div>
                        <ChevronRight className="text-purple-400" size={16} />
                        <div className="bg-purple-600/40 px-4 py-2 rounded font-bold text-lg">💰 FUNDED</div>
                    </div>
                </div>
            </div>
        </div>
    )
},
                // Slide 3: Why Speed Matters
                {
                    content: (
                        <div className="h-full p-16">
                            <h2 className="text-4xl font-bold mb-12 text-center">Why Speed Matters in 2025</h2>
                            <div className="grid grid-cols-2 gap-8">
                                <div className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 rounded-xl p-8 transform hover:scale-105 transition-transform">
                                    <Zap size={48} className="text-yellow-400 mb-4" />
                                    <h3 className="text-2xl font-bold mb-4">AI + Healthcare is HOT</h3>
                                    <p className="text-lg text-gray-300">Funding windows close fast. What's hot today is cold tomorrow.</p>
                                </div>
                                <div className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 rounded-xl p-8 transform hover:scale-105 transition-transform">
                                    <Users size={48} className="text-blue-400 mb-4" />
                                    <h3 className="text-2xl font-bold mb-4">Competition is Real</h3>
                                    <p className="text-lg text-gray-300">10 other teams are building therapy matching RIGHT NOW.</p>
                                </div>
                                <div className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 rounded-xl p-8 transform hover:scale-105 transition-transform">
                                    <AlertCircle size={48} className="text-orange-400 mb-4" />
                                    <h3 className="text-2xl font-bold mb-4">Angel FOMO</h3>
                                    <p className="text-lg text-gray-300">Angels invest when others are investing. Momentum breeds momentum.</p>
                                </div>
                                <div className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 rounded-xl p-8 transform hover:scale-105 transition-transform">
                                    <Rocket size={48} className="text-purple-400 mb-4" />
                                    <h3 className="text-2xl font-bold mb-4">First-Mover Advantage</h3>
                                    <p className="text-lg text-gray-300">Our AI voice matching advantage disappears if we move slowly.</p>
                                </div>
                            </div>
                        </div>
                    )
                },
                // Slide 4: The $1M-$2M Strategy
{
    content: (
        <div className="h-full p-16">
            <h2 className="text-4xl font-bold mb-8 text-center">The $1M-$2M Strategy</h2>
            <div className="grid grid-cols-1 gap-4">
                <div className="bg-gradient-to-r from-purple-900/30 to-purple-900/10 rounded-xl p-5 border-l-4 border-purple-400">
                    <div className="flex justify-between items-center">
                        <div>
                            <h3 className="text-xl font-bold text-purple-400">Phase 1: Weeks 1-3</h3>
                            <p className="text-lg font-semibold">First $500K from 5 angels ($100K each)</p>
                        </div>
                        <div className="text-right">
                            <p className="text-3xl font-bold text-purple-300">$500K</p>
                            <p className="text-sm text-gray-600">25% of goal</p>
                        </div>
                    </div>
                    <p className="text-sm text-gray-800 mt-2">Target: Angels who "get it" immediately - healthcare operators, AI engineers</p>
                </div>
                
                <div className="bg-gradient-to-r from-blue-900/30 to-blue-900/10 rounded-xl p-5 border-l-4 border-blue-400">
                    <div className="flex justify-between items-center">
                        <div>
                            <h3 className="text-xl font-bold text-blue-400">Phase 2: Weeks 3-5</h3>
                            <p className="text-lg font-semibold">Next $500K from 10 angels ($50K each)</p>
                        </div>
                        <div className="text-right">
                            <p className="text-3xl font-bold text-blue-300">$1M</p>
                            <p className="text-sm text-gray-800">50% of goal</p>
                        </div>
                    </div>
                    <p className="text-sm text-gray-700 mt-2">Momentum message: "We're 50% committed, closing fast"</p>
                </div>
                
                <div className="bg-gradient-to-r from-green-900/30 to-green-900/10 rounded-xl p-5 border-l-4 border-green-400">
                    <div className="flex justify-between items-center">
                        <div>
                            <h3 className="text-xl font-bold text-green-400">Phase 3: Weeks 5-6</h3>
                            <p className="text-lg font-semibold">Oversubscription to $1.5-2M</p>
                        </div>
                        <div className="text-right">
                            <p className="text-3xl font-bold text-green-300">$2M</p>
                            <p className="text-sm text-gray-800">100%+ goal</p>
                        </div>
                    </div>
                    <p className="text-sm text-gray-700 mt-2">"Round is closing, still room for the right strategic angels"</p>
                </div>
            </div>
            
            <div className="mt-6 bg-yellow-900/20 rounded-xl p-4 text-center">
                <p className="text-lg font-bold text-yellow-400">💡 Key: Each phase creates urgency for the next</p>
                <div className="flex justify-center items-center mt-2 space-x-2 text-sm">
                    <span className="text-purple-300">25% raised</span>
                    <ChevronRight size={16} className="text-yellow-400" />
                    <span className="text-blue-300">50% raised</span>
                    <ChevronRight size={16} className="text-yellow-400" />
                    <span className="text-green-300">100%+ raised</span>
                </div>
            </div>
        </div>
    )
},
// New slide to add after the current slides
{
    content: (
        <div className="h-full p-16">
            <h2 className="text-4xl font-bold mb-8 text-center">Finding Your Angel Connectors</h2>
            <div className="grid grid-cols-2 gap-6">
                <div>
                    <h3 className="text-xl font-bold mb-4 text-purple-400 flex items-center">
                        <Users size={28} className="mr-2" />
                        Where to Find Connectors
                    </h3>
                    <div className="space-y-3">
                        <div className="bg-purple-900/20 p-3 rounded-lg">
                            <p className="font-bold text-purple-300">LinkedIn Groups</p>
                            <p className="text-sm">• Healthcare Innovation Network</p>
                            <p className="text-sm">• AI in Healthcare Professionals</p>
                            <p className="text-sm">• Digital Health Founders</p>
                        </div>
                        <div className="bg-blue-900/20 p-3 rounded-lg">
                            <p className="font-bold text-blue-300">Threads/X Communities</p>
                            <p className="text-sm">• Follow #HealthTech #AIHealth founders</p>
                            <p className="text-sm">• Engage with their content genuinely</p>
                            <p className="text-sm">• Share your Amy demos</p>
                        </div>
                        <div className="bg-green-900/20 p-3 rounded-lg">
                            <p className="font-bold text-green-300">Online Events (Free!)</p>
                            <p className="text-sm">• HIMSS virtual sessions</p>
                            <p className="text-sm">• StartUp Health webinars</p>
                            <p className="text-sm">• AI Med virtual meetups</p>
                        </div>
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-bold mb-4 text-orange-400 flex items-center">
                        <Zap size={28} className="mr-2" />
                        How to Get Intros Fast
                    </h3>
                    <div className="space-y-3">
                        <div className="bg-orange-900/20 p-3 rounded-lg">
                            <p className="font-bold text-orange-300">The "Value First" DM</p>
                            <p className="text-sm">"Saw your post about therapist burnout. We solved the 75% dropout rate with AI matching. Happy to share what we learned - no pitch."</p>
                        </div>
                        <div className="bg-yellow-900/20 p-3 rounded-lg">
                            <p className="font-bold text-yellow-300">Leverage Your Practice</p>
                            <p className="text-sm">• Your 30K patients = credibility</p>
                            <p className="text-sm">• Other practice owners know angels</p>
                            <p className="text-sm">• Medical societies have investor members</p>
                        </div>
                        <div className="bg-red-900/20 p-3 rounded-lg">
                            <p className="font-bold text-red-300">The Ask Formula</p>
                            <p className="text-sm">"We're raising $1M for Mindaera (AI therapy matching). Already $300K committed. Know any angels interested in mental health? 2-min video here: [link]"</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl p-4">
                <p className="text-lg font-bold mb-2">🎯 This Week's Connector Challenge</p>
                <div className="grid grid-cols-4 gap-4 text-center text-sm">
                    <div className="bg-black/30 rounded p-2">
                        <p className="font-bold text-2xl">100</p>
                        <p>LinkedIn DMs</p>
                    </div>
                    <div className="bg-black/30 rounded p-2">
                        <p className="font-bold text-2xl">50</p>
                        <p>Twitter/Threads replies</p>
                    </div>
                    <div className="bg-black/30 rounded p-2">
                        <p className="font-bold text-2xl">2</p>
                        <p>Virtual events</p>
                    </div>
                    <div className="bg-black/30 rounded p-2">
                        <p className="font-bold text-2xl">50</p>
                        <p>New connections</p>
                    </div>
                </div>
            </div>
        </div>
    )
},
                // Slide 5: Your Role as Founders
                {
    content: (
        <div className="h-full p-16">
            <h2 className="text-4xl font-bold mb-8 text-center">Your Role as Founders</h2>
            <div className="grid grid-cols-2 gap-8">
                <div>
                    <h3 className="text-xl font-bold mb-4 text-green-400 flex items-center">
                        <CheckCircle size={28} className="mr-2" />
                        CEO (Erik) - Lead the Charge
                    </h3>
                    <ul className="space-y-3">
                        <li className="bg-green-900/20 p-3 rounded-lg">
                            <span className="font-bold">Own every intro</span><br/>
                            <span className="text-sm">Reply within 2 hours, book calls immediately</span>
                        </li>
                        <li className="bg-green-900/20 p-3 rounded-lg">
                            <span className="font-bold">Drive the narrative</span><br/>
                            <span className="text-sm">"We're closing in 2 weeks" - create FOMO</span>
                        </li>
                        <li className="bg-green-900/20 p-3 rounded-lg">
                            <span className="font-bold">Close on calls</span><br/>
                            <span className="text-sm">Get verbal commits, send docs same day</span>
                        </li>
                        <li className="bg-green-900/20 p-3 rounded-lg">
                            <span className="font-bold">Update investors weekly</span><br/>
                            <span className="text-sm">"We're at $X, closing fast"</span>
                        </li>
                    </ul>
                </div>
                <div>
                    <h3 className="text-xl font-bold mb-4 text-blue-400 flex items-center">
                        <Users size={28} className="mr-2" />
                        CTO + CPO - Support & Amplify
                    </h3>
                    <ul className="space-y-3">
                        <li className="bg-blue-900/20 p-3 rounded-lg">
                            <span className="font-bold">CTO: Demo Amy flawlessly</span><br/>
                            <span className="text-sm">3-min live demo that drops jaws</span>
                        </li>
                        <li className="bg-blue-900/20 p-3 rounded-lg">
                            <span className="font-bold">CPO: Share clinical validation</span><br/>
                            <span className="text-sm">"95% match rate from our practice"</span>
                        </li>
                        <li className="bg-blue-900/20 p-3 rounded-lg">
                            <span className="font-bold">Both: Join key calls</span><br/>
                            <span className="text-sm">Technical depth + clinical credibility</span>
                        </li>
                        <li className="bg-blue-900/20 p-3 rounded-lg">
                            <span className="font-bold">Create content</span><br/>
                            <span className="text-sm">Video demos, case studies, LinkedIn posts</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="mt-6 bg-yellow-900/20 rounded-xl p-4 text-center">
                <p className="text-lg font-bold text-yellow-400">Remember: CEO drives speed, CTO/CPO provide proof</p>
                <p className="text-sm mt-2">Every interaction should feel urgent, credible, and exciting</p>
            </div>
        </div>
    )
},
                // Slide 6: The Perfect Angel Email (with Video)
{
    content: (
        <div className="h-full p-16">
            <h2 className="text-4xl font-bold mb-8 text-center">The Perfect Angel Email</h2>
            <div className="grid grid-cols-2 gap-6">
                {/* Responding to Intro */}
                <div>
                    <h3 className="text-xl font-bold mb-4 text-green-400">Responding to Intro</h3>
                    <div className="bg-gray-900 rounded-xl p-6 font-mono text-xs">
                        <div className="mb-3">
                            <span className="text-gray-500">Subject:</span> 
                            <span className="text-green-400"> Re: Intro - Mindaera AI therapy matching</span>
                        </div>
                        <div className="space-y-3 text-gray-300">
                            <p>Hi [Name],</p>
                            <p>Thanks for the intro [Connector]!</p>
                            <p>[Name], we're solving the <span className="text-yellow-400 font-bold">75% dropout rate</span> in therapy by using AI voice analysis to match patients with the RIGHT therapist.</p>
                            <p>Quick stats: <span className="text-green-400 font-bold">95% match satisfaction</span>, <span className="text-blue-400 font-bold">3 clinical partnerships</span>, raising $1M through SAFE agreements. We're accepting $100K+ tickets. We already have <span className="text-purple-400 font-bold">$300K committed/wired</span>.</p>
                            <p>📹 <span className="text-purple-400 underline">2-min demo of Amy in action</span> </p>
                            <p>Would love to dive deeper - grab 15 min? <span className="text-blue-400 underline">calendly.com/mindaera/15min</span></p>
                            <p>Best,<br/>Erik Rüütel</p>
                        </div>
                    </div>
                    <div className="mt-4 bg-green-900/20 rounded p-3 text-sm">
                        <p className="font-bold text-green-400">Key elements:</p>
                        <ul className="mt-1 space-y-1">
                            <li>• Video BEFORE calendar link</li>
                            <li>• "Our investors love this" = social proof</li>
                            <li>• Keep video under 2 minutes</li>
                            <li>• <span className="font-bold">Reply within 2 hours!</span></li>
                        </ul>
                    </div>
                </div>

                {/* Cold Outreach */}
                <div>
                    <h3 className="text-xl font-bold mb-4 text-blue-400">Cold Outreach</h3>
                    <div className="bg-gray-900 rounded-xl p-6 font-mono text-xs">
                        <div className="mb-3">
                            <span className="text-gray-500">Subject:</span> 
                            <span className="text-green-400"> Mindaera - AI matching for therapy (via [Connector])</span>
                        </div>
                        <div className="space-y-3 text-gray-300">
                            <p>Hi [Name],</p>
                            <p>Saw you invested in [Portfolio Company] - we're solving a similar problem in mental health.</p>
                            <p>Therapy has a massive problem: <span className="text-yellow-400 font-bold">75% of patients quit</span> because they're matched with the wrong therapist. Our AI (Amy) uses voice analysis to match based on personality fit, not just availability.</p>
                            <p>Traction: <span className="text-green-400 font-bold">95% match satisfaction</span>, <span className="text-blue-400 font-bold">3 clinical partnerships</span>, raising $1M with <span className="text-purple-400 font-bold">$300K committed</span> from [Notable Angel].</p>
                            <p>See Amy in action: 📹 <span className="text-purple-400 underline">2-min demo</span></p>
                            <p>Let's have a quick 15 minutes chat: <span className="text-blue-400 underline">calendly.com/mindaera/15min</span></p>
                            <p>Best,<br/>Erik Rüütel<br/>CEO, Mindaera</p>
                        </div>
                    </div>
                    <div className="mt-4 bg-blue-900/20 rounded p-3 text-sm">
                        <p className="font-bold text-blue-400">Cold outreach tactics:</p>
                        <ul className="mt-1 space-y-1">
                            <li>• Reference their portfolio/interests</li>
                            <li>• Name-drop committed investors</li>
                            <li>• Lead with the problem, not your solution</li>
                            <li>• Include your title (CEO)</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Bottom tips */}
            <div className="mt-6 bg-yellow-900/20 rounded-xl p-4">
                <p className="text-lg font-bold text-yellow-400 mb-2">🎥 Video Demo Best Practices:</p>
                <div className="grid grid-cols-3 gap-4 text-sm">
                    <div className="bg-yellow-800/20 rounded p-2">
                        <p className="font-bold">0-30 sec:</p>
                        <p>Hook + Amy speaking</p>
                    </div>
                    <div className="bg-yellow-800/20 rounded p-2">
                        <p className="font-bold">30-90 sec:</p>
                        <p>Live matching demo</p>
                    </div>
                    <div className="bg-yellow-800/20 rounded p-2">
                        <p className="font-bold">90-120 sec:</p>
                        <p>Team + Call to action to book a calendly slot</p>
                    </div>
                </div>
            </div>
        </div>
    )
},
                // Slide 7: Real Examples
                {
                    content: (
                        <div className="h-full p-16">
                            <h2 className="text-4xl font-bold mb-12 text-center">Real Examples - How Fast Winners Move</h2>
                            <div className="space-y-8">
                                <div className="bg-gradient-to-r from-purple-900/30 to-blue-900/30 rounded-xl p-8">
                                    <div className="flex justify-between items-start mb-4">
                                        <h3 className="text-2xl font-bold">Rad AI (Healthcare + AI, 2024)</h3>
                                        <span className="bg-green-500 text-black px-3 py-1 rounded-full text-sm font-bold">SUCCESS</span>
                                    </div>
                                    <div className="grid grid-cols-3 gap-4 text-center">
                                        <div>
                                            <p className="text-3xl font-bold text-purple-400">$2M → $4M</p>
                                            <p className="text-sm text-gray-700">Oversubscribed 2x</p>
                                        </div>
                                        <div>
                                            <p className="text-3xl font-bold text-blue-400">3 weeks</p>
                                            <p className="text-sm text-gray-700">Total time</p>
                                        </div>
                                        <div>
                                            <p className="text-3xl font-bold text-green-400">WhatsApp</p>
                                            <p className="text-sm text-gray-700">Main channel</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gradient-to-r from-blue-900/30 to-green-900/30 rounded-xl p-8">
                                    <div className="flex justify-between items-start mb-4">
                                        <h3 className="text-2xl font-bold">Ambience Healthcare (2023)</h3>
                                        <span className="bg-yellow-500 text-black px-3 py-1 rounded-full text-sm font-bold">MEGA SUCCESS</span>
                                    </div>
                                    <div className="grid grid-cols-3 gap-4 text-center">
                                        <div>
                                            <p className="text-3xl font-bold text-purple-400">$1.5M</p>
                                            <p className="text-sm text-gray-700">Angel round</p>
                                        </div>
                                        <div>
                                            <p className="text-3xl font-bold text-blue-400">10 days</p>
                                            <p className="text-sm text-gray-700">Close time</p>
                                        </div>
                                        <div>
                                            <p className="text-3xl font-bold text-green-400">$500M</p>
                                            <p className="text-sm text-gray-700">Current valuation</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-8 bg-yellow-900/20 rounded-xl p-6 text-center">
                                <p className="text-xl"><span className="font-bold text-yellow-400">Pattern:</span> Live demos + Fast decisions + Creating FOMO = Success</p>
                            </div>
                        </div>
                    )
                },
                // Slide 8: Your Homework
                {
                    content: (
                        <div className="h-full p-16">
                            <h2 className="text-4xl font-bold mb-12 text-center">Your Homework</h2>
                            <div className="max-w-4xl mx-auto space-y-4">
                                <div className="bg-gradient-to-r from-purple-900/30 to-purple-900/10 rounded-xl p-6 flex items-center space-x-4 transform hover:scale-105 transition-transform">
                                    <div className="text-3xl font-bold text-purple-400">1</div>
                                    <div>
                                        <h3 className="text-xl font-bold">Make list of 50 potential angels</h3>
                                        <p className="text-gray-700">Use LinkedIn, Twitter, AngelList, Crunchbase, signal.nfx</p>
                                    </div>
                                </div>
                                <div className="bg-gradient-to-r from-blue-900/30 to-blue-900/10 rounded-xl p-6 flex items-center space-x-4 transform hover:scale-105 transition-transform">
                                    <div className="text-3xl font-bold text-blue-400">2</div>
                                    <div>
                                        <h3 className="text-xl font-bold">Find mutual connections</h3>
                                        <p className="text-gray-700">Map out warm intro paths for each angel</p>
                                    </div>
                                </div>
                                <div className="bg-gradient-to-r from-green-900/30 to-green-900/10 rounded-xl p-6 flex items-center space-x-4 transform hover:scale-105 transition-transform">
                                    <div className="text-3xl font-bold text-green-400">3</div>
                                    <div>
                                        <h3 className="text-xl font-bold">Prepare 3-minute Amy demo</h3>
                                        <p className="text-gray-700">Practice until it's smooth and impressive</p>
                                    </div>
                                </div>
                                <div className="bg-gradient-to-r from-yellow-900/30 to-yellow-900/10 rounded-xl p-6 flex items-center space-x-4 transform hover:scale-105 transition-transform">
                                    <div className="text-3xl font-bold text-yellow-400">4</div>
                                    <div>
                                        <h3 className="text-xl font-bold">Set up Calendly</h3>
                                        <p className="text-gray-700">Enable instant booking, no back-and-forth</p>
                                    </div>
                                </div>
                                <div className="bg-gradient-to-r from-red-900/30 to-red-900/10 rounded-xl p-6 flex items-center space-x-4 transform hover:scale-105 transition-transform">
                                    <div className="text-3xl font-bold text-red-400">5</div>
                                    <div>
                                        <h3 className="text-xl font-bold">Practice the urgency message</h3>
                                        <p className="text-gray-700">"First close in 2 weeks" - say it naturally</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                },
                // Slide 9: The Mindaera Advantage
                {
                    content: (
                        <div className="h-full p-16">
                            <h2 className="text-4xl font-bold mb-12 text-center">The Mindaera Advantage</h2>
                            <div className="grid grid-cols-2 gap-8 mb-12">
                                <div className="bg-gradient-to-br from-purple-900/30 to-blue-900/30 rounded-xl p-8 text-center">
                                    <Target size={48} className="mx-auto mb-4 text-purple-400" />
                                    <h3 className="text-2xl font-bold mb-4">Hot Market Timing</h3>
                                    <p className="text-xl text-gray-300">AI + Mental Health = 🔥</p>
                                </div>
                                <div className="bg-gradient-to-br from-blue-900/30 to-green-900/30 rounded-xl p-8 text-center">
                                    <Zap size={48} className="mx-auto mb-4 text-yellow-400" />
                                    <h3 className="text-2xl font-bold mb-4">Working Product</h3>
                                    <p className="text-xl text-gray-300">Amy is LIVE, not just slides</p>
                                </div>
                                <div className="bg-gradient-to-br from-green-900/30 to-yellow-900/30 rounded-xl p-8 text-center">
                                    <Users size={48} className="mx-auto mb-4 text-green-400" />
                                    <h3 className="text-2xl font-bold mb-4">Proven Team</h3>
                                    <p className="text-xl text-gray-300">60+ years, 10k patients</p>
                                </div>
                                <div className="bg-gradient-to-br from-yellow-900/30 to-red-900/30 rounded-xl p-8 text-center">
                                    <Rocket size={48} className="mx-auto mb-4 text-orange-400" />
                                    <h3 className="text-2xl font-bold mb-4">Clear Path to $100M</h3>
                                    <p className="text-xl text-gray-300">Just 10% of BetterHelp</p>
                                </div>
                            </div>
                            <div className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-xl p-8 text-center">
                                <h3 className="text-3xl font-bold mb-4">Let's run at Startup speeds</h3>
                                <div className="grid grid-cols-2 gap-8 mt-6">
                                    <div className="bg-black/30 rounded-lg p-4">
                                        <p className="text-xl"><span className="text-green-400 font-bold">in 2 weeks:</span> </p>
                                        <p className="text-2xl font-bold mt-2">First $100k+ in the  bank</p>
                                    </div>
                                    <div className="bg-black/30 rounded-lg p-4">
                                        <p className="text-xl"><span className="text-red-400 font-bold">August 31st:</span></p>
                                        <p className="text-2xl font-bold mt-2">$2M closed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            ];

            return (
                <div className="h-screen flex flex-col bg-gradient-to-br from-gray-900 via-purple-900/20 to-gray-900">
                    <style jsx>{`
                        @keyframes slideIn {
                            from {
                                opacity: 0;
                                transform: translateX(50px);
                            }
                            to {
                                opacity: 1;
                                transform: translateX(0);
                            }
                        }
                        .slide-content {
                            animation: slideIn 0.5s ease-out;
                        }
                    `}</style>
                    
                    {/* Progress bar */}
                    <div className="h-1 bg-gray-800">
                        <div 
                            className="h-full bg-gradient-to-r from-purple-500 to-blue-500 transition-all duration-300"
                            style={{ width: `${((currentSlide + 1) / slides.length) * 100}%` }}
                        />
                    </div>

                    {/* Main content */}
                    <div className="flex-1 overflow-hidden">
                        <div key={animationKey} className="h-full slide-content">
                            {slides[currentSlide].content}
                        </div>
                    </div>

{/* Navigation */}
                   <div className="p-8 flex justify-between items-center">
                       <button
                           onClick={prevSlide}
                           className={`flex items-center space-x-2 px-6 py-3 rounded-lg transition-all ${
                               currentSlide === 0 
                                   ? 'bg-gray-800 text-gray-600 cursor-not-allowed' 
                                   : 'bg-gray-800 hover:bg-gray-700 text-white'
                           }`}
                           disabled={currentSlide === 0}
                       >
                           <ChevronLeft size={20} />
                           <span>Previous</span>
                       </button>

                       <div className="flex space-x-2">
                           {slides.map((_, index) => (
                               <div
                                   key={index}
                                   className={`h-2 rounded-full transition-all ${
                                       index === currentSlide 
                                           ? 'w-8 bg-purple-500' 
                                           : 'w-2 bg-gray-700'
                                   }`}
                               />
                           ))}
                       </div>

                       <button
                           onClick={nextSlide}
                           className={`flex items-center space-x-2 px-6 py-3 rounded-lg transition-all ${
                               currentSlide === slides.length - 1 
                                   ? 'bg-gray-800 text-gray-600 cursor-not-allowed' 
                                   : 'bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white'
                           }`}
                           disabled={currentSlide === slides.length - 1}
                       >
                           <span>Next</span>
                           <ChevronRight size={20} />
                       </button>
                   </div>

                   <div className="text-center pb-4 text-gray-500 text-sm">
                       Use arrow keys to navigate • Slide {currentSlide + 1} of {slides.length}
                   </div>
               </div>
           );
       };
       export default FundraisingWorkshop;